import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BrandMark } from "@/components/BrandMark";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleAuth() {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Welcome back!");
      const r = res.user.role;
      navigate(r === "staff" ? "/staff" : r === "admin" || r === "super_admin" ? "/admin" : "/ricepoints");
    } else setError(res.error);
  };

  return (
    <div className="mx-auto max-w-md px-4 py-14">
      <div className="flex justify-center mb-6">
        <BrandMark iconSize={46} textSize="text-2xl" teluguSize="text-base" />
      </div>
      <div className="bg-card border border-border rounded-xl p-6 sm:p-8">
        <h1 className="font-heading font-bold text-2xl">Welcome back</h1>
        <p className="text-sm text-muted-foreground mt-1">Login to view your RicePoints and orders.</p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="email">Email</Label>
            <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" className="mt-1.5" placeholder="you@example.com" />
          </div>
          <div>
            <Label htmlFor="password">Password</Label>
            <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" className="mt-1.5" placeholder="••••••••" />
          </div>
          {error && <div className="text-sm text-destructive" data-testid="login-error">{error}</div>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="login-submit">{busy ? "Logging in…" : "Login"}</Button>
        </form>
        <div className="my-4 flex items-center gap-3 text-xs text-muted-foreground"><div className="h-px bg-border flex-1" /> OR <div className="h-px bg-border flex-1" /></div>
        <Button variant="outline" className="w-full" onClick={googleAuth} data-testid="google-login-btn">Continue with Google</Button>
        <p className="mt-6 text-sm text-center text-muted-foreground">
          New here? <Link to="/register" className="text-primary font-semibold" data-testid="to-register">Create an account</Link>
        </p>
        <div className="mt-4 text-xs text-muted-foreground bg-muted rounded-md p-3">
          Demo customer: <b>rahul@demo.com</b> / <b>Demo@123</b>
        </div>
      </div>
    </div>
  );
}
